import VisualPlaceholder from '@components/VisualPlaceholder/VisualPlaceholder';
import IngkaImage, { ImageProps } from '@ingka/image';
import React from 'react';

const Image = (props: ImageProps) => {
    const { src, className } = props;

    if (src) {
        return <IngkaImage prefix="list-ingka-" {...props} />;
    } else {
        return <VisualPlaceholder className={className} />;
    }
};

export default Image;
